module.exports = __webpack_public_path__ + "img/V-45-ER-1000-BB.77afa980.png";